
"use client";

export default function ViewIcon({ className = "", ...props }) {
  return (
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}
    {...props}>
<path d="M37.0444 19.1376C37.9203 20.2205 37.9203 21.7796 37.0444 22.8624C34.3176 26.2332 27.4665 33.0001 20.0014 33.0001C12.5362 33.0001 5.6824 26.2332 2.95562 22.8624C2.07969 21.7795 2.07969 20.2204 2.95562 19.1375C5.6824 15.7668 12.5361 9 20.0013 9C27.4664 9 34.3175 15.7668 37.0444 19.1376Z" stroke="currentColor" strokeWidth="2.8802" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M20.0013 27C23.315 27 26.0013 24.3137 26.0013 21C26.0013 17.6863 23.315 15 20.0013 15C16.6876 15 14.0013 17.6863 14.0013 21C14.0013 24.3137 16.6876 27 20.0013 27Z" stroke="currentColor" strokeWidth="2.8802" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  );
}
